/**
 * Mixin containing utility methods required to render Wizer's DataTable, ensure entry uniqueness
 * and execute validations on entries. To be used in components which have Wizer's DataTable
 * as a child component.
 * Component using this mixin should have these fields as part of its data:
 * isDirty Boolean

 */
export default {
  methods: {
    getElementIndex(dataToCheck, dataSource, uniqueAttrib) {
      if (!dataSource) {
        return -1
      }
      return dataSource.findIndex((entry) => entry[uniqueAttrib] === dataToCheck[uniqueAttrib])
    },
    onElementModified(entry, entryIndex, currentIndex, allEntries) {
      if (entryIndex === -1) {
        // Newly added
        allEntries.push(entry)
        return
      }
      if (currentIndex !== -1 && currentIndex === entryIndex) {
        // Existing entry updated (name can be the same as before)
        allEntries.splice(currentIndex, 1, entry)
      }
      if (currentIndex === -1 && entryIndex !== -1) {
        // Existing entry updated with unique name
        allEntries.splice(entryIndex, 1, entry)
      }
    },
    /**
     * Action to be executed on DataTable's delete click for selected items
     * @param selectedItems array of selected items
     * @param uniqueAttributeName name of the unique attribute in an array. Elements are deleted from the array by this attribute
     * @param dataSource variable holding the data array
     * @param arrayAttributeName name of the array attribute. Because of the JS pass-by-value nature, we can only modify the original array by having a reference to it
     * @param dataTableRefName ref name of the Wizer's DataTable element
     */
    onDeleteClick(
      selectedItems,
      uniqueAttributeName,
      dataSource,
      arrayAttributeName,
      dataTableRefName,
    ) {
      const itemNamesToRemove = selectedItems.map((item) => item[uniqueAttributeName])
      dataSource[arrayAttributeName] = dataSource[arrayAttributeName].filter(
        (item) => itemNamesToRemove.indexOf(item[uniqueAttributeName]) === -1,
      )
      this.$refs[dataTableRefName].deselectAll()
      this.isDirty = true
    },
    async validateEntry(entryData, entryIndex, currentIndex, errorMsg) {
      if (currentIndex !== -1 && currentIndex !== entryIndex) {
        const message = errorMsg
        const notification = { type: 'error', message }
        await this.$store.dispatch('Notification/add', notification, { root: true })
        return false
      }
      return true
    },
  },
}
